import { takeLatest, put, call, all } from "redux-saga/effects";
import * as allActions from "../../actions";
import axiosMain from "../../../http/axios/axios_main";
import * as labels from "../../actionLabels";
import CustomToast from "../../../components/Toast";
function* sellertoauctioneerinvoice_search_Sagas(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/postauction/sellertoauctioneerinvoice/search",
      action.payload
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(
          allActions.sellertoauctioneerinvoice_search_Success(response.data)
        );
        yield put(allActions.sellertoauctioneerApiStutas(true));
      } else {
        CustomToast.error(response.data.message);
        yield put(
          allActions.sellertoauctioneerinvoice_search_Fail(response.data)
        );
      }
    } else {
      CustomToast.error(response.data);
      yield put(
        allActions.sellertoauctioneerinvoice_search_Fail(
          response.data || "Unknown error occurred."
        )
      );
    }
  } catch (error) {
    // yield put(
    //   allActions.get_searchinvoiceFail(
    //     error.message || "Unknown error occurred."
    //   )
    // );
  }
  finally {
    yield put(allActions.enableSearchInvoiceButton());            
  }
}

function* viewinvoicedetail_Sagas(action) {
  try {
    const response = yield call(
      axiosMain.get,
      "/postauction/sellertoauctioneerinvoice/viewInvoiceDetail/" + action.payload + "/" + 0 + "/" + 0
    );
    // const response = yield call(
    //   axiosMain.get,
    //   "/postauction/sellertoauctioneerinvoice/viewInvoiceDetail/"+invoiceDetailId+"/"+exportType+"/"+isExport
    // );

    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        yield put(allActions.viewinvoicedetail_Success(response.data));
      } else {
        yield put(allActions.viewinvoicedetail_Fail(response.data.message));
      }
    } else {
      yield put(
        allActions.viewinvoicedetail_Fail(
          response.data.message || "Unknown error occurred."
        )
      );
    }
  } catch (error) {
    yield put(
      allActions.viewinvoicedetail_Fail(
        error.message || "Unknown error occurred."
      )
    );
  }
}


// function* getInvoiceAuctionById(action) {
//   try {
//     let isExport = action.payload.isExport == undefined ? 0 : action.payload.isExport;
//     let exportType = action.payload.exportType  == undefined ? 0 : action.payload.exportType;
//     let invoiceDetailId = action.payload.invoiceDetailId;
//     const Invoice = yield call(
//       axiosMain.get,
//       "/postauction/sellertoauctioneerinvoice/viewInvoiceDetail/"+invoiceDetailId+"/"+exportType+"/"+isExport
//     );
//     if (Invoice.status == 200) {
//       if(isExport==1){
//         yield put(getSellerInvoiceByIdActionSuccess(Invoice.data));
//       }else{
//         const updatedResponseData = Invoice.data.responseData.map(item => ({
//           ...item,
//           sahilinvoiceDetailId: invoiceDetailId // Add action.payload to each item
//         }));
//         yield put(getSellerInvoiceByIdActionSuccess( {...Invoice.data,
//           responseData: updatedResponseData}));
//       }
      
//     } else {
//       yield put(getSellerInvoiceByIdActionSuccess(Invoice.massage));
//     }
//   } catch (error) {
//     yield put(getSellerInvoiceByIdActionFail(error));
//   }
// }


function* sellertoauctioneerinvoice_create_Sagas(action) {
  try {
    const response = yield call(
      axiosMain.post,
      "/postauction/sellertoauctioneerinvoice/Create",
      action.payload
    );
    if (response.status == 200) {
      if (response.data.statusCode == 200) {
        CustomToast.success(response.data.message);
        yield put(
          allActions.sellertoauctioneerinvoice_create_Success(response.data)

        );
      } else {
        CustomToast.error(response.data.message);
        yield put(
          allActions.sellertoauctioneerinvoice_create_Fail(
            response.data.message
          )
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(
        allActions.sellertoauctioneerinvoice_create_Fail(
          response.data.message || "Unknown error occurred."
        )
      );
    }
  } catch (error) {
    yield put(
      allActions.sellertoauctioneerinvoice_create_Fail(
        error.message || "Unknown error occurred."
      )
    );
  } finally {
    yield put(allActions.enableGenerateInvoiceButton());            
  }
}

export function* generateSellerTaxInvoiceSagas() {
  yield all([
    yield takeLatest(
      labels.SELLERTOAUCTIONEERINVOICE_SEARCH,
      sellertoauctioneerinvoice_search_Sagas
    ),
    yield takeLatest(
      labels.SELLERTOAUCTIONEERINVOICE_VIEWINVOICEDETAIL,
      viewinvoicedetail_Sagas
    ),
    yield takeLatest(
      labels.SELLERTOAUCTIONEERINVOICE_CREATE,
      sellertoauctioneerinvoice_create_Sagas
    ),
  ]);
}
